import FailPage from './FailPage';
export default FailPage;



// WEBPACK FOOTER //
// ./src/components/Payments/FailPage/index.js